const env: typeof window._env_ =
  process.env.NODE_ENV === 'development'
    ? {
        REACT_APP_HOST: process.env.REACT_APP_HOST || 'http://192.168.200.210:8080/api',
        REACT_APP_NO_LOG: 'false',
        REACT_APP_RAW_REPORT_PAGE: process.env.REACT_APP_RAW_REPORT_PAGE || 'http://localhost:3000',
      }
    : // eslint-disable-next-line no-underscore-dangle
      window._env_ || {
        REACT_APP_HOST: '',
        REACT_APP_NO_LOG: 'true',
        REACT_APP_RAW_REPORT_PAGE: '',
      };

export default env;
